import Box from "@mui/material/Box";
import { AddButton } from "app/components/Button/AddButton";
import BreadCrumb from "app/components/BreadCrumb";
import { ScrollableView } from "app/components/ScrollableView";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useInjectReducer, useInjectSaga } from "utils/redux-injectors";

import AddHydraulicWallModal from "./components/AddHydraulicWallModal";
import HydraulicWallTable from "./components/HydraulicWallTable";
import {
  selectHydraulicWallList,
  selectHydraulicWallLoading,
  selectHydraulicWallMeta,
} from "./redux/selector";
import hydraulicWallSaga from "./redux/saga";
import { hydraulicWallActions, reducer, sliceKey } from "./redux/slice";
import { useStyles } from "./styles";

const HydraulicWall = () => {
  const { t, i18n } = useTranslation();
  const styles = useStyles();
  const dispatch = useDispatch();

  useInjectReducer({
    key: sliceKey,
    reducer,
  });

  useInjectSaga({
    key: sliceKey,
    saga: hydraulicWallSaga,
  });

  const rows = useSelector(selectHydraulicWallList);
  const loading = useSelector(selectHydraulicWallLoading);
  const meta = useSelector(selectHydraulicWallMeta);

  useEffect(() => {
    dispatch(hydraulicWallActions.getHydraulicWallList());
  }, [dispatch]);

  const hasMoreItems = meta.currentPage < meta.totalPages;

  const getNextPage = () => {
    if (!loading && hasMoreItems) {
      dispatch(hydraulicWallActions.getNextPageItems());
    }
  };

  return (
    <Box className={styles.container}>
      <Box className={styles.scrollContent} dir={i18n.dir()}>
        <Box className={styles.pageContent}>
          <BreadCrumb
            title={t("SIDEBAR.HYDRAULIC_TAILGATE_TYPE")}
            iconPosition="end"
          />
          <Box dir="ltr">
            <AddButton
              label={t("HYDRAULIC_WALL.ACTIONS.ADD")}
              onClick={() => dispatch(hydraulicWallActions.openAddModal())}
            />
          </Box>
          <Box className={styles.tableContainer}>
            <ScrollableView
              borderless
              height="calc(100vh - 200px)"
              loadMore={getNextPage}
              hasMoreItems={hasMoreItems}
            >
              <HydraulicWallTable rows={rows} loading={loading} />
            </ScrollableView>
          </Box>
        </Box>
      </Box>
      <AddHydraulicWallModal />
    </Box>
  );
};

export default HydraulicWall;
